import { render, staticRenderFns } from "./CoinPurchase.vue?vue&type=template&id=308cabca&scoped=true"
import script from "./CoinPurchase.vue?vue&type=script&lang=js"
export * from "./CoinPurchase.vue?vue&type=script&lang=js"
import style0 from "./CoinPurchase.vue?vue&type=style&index=0&id=308cabca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308cabca",
  null
  
)

export default component.exports